import React, { useState } from 'react';
import GetIcon from '../../../../utils/Icon';
import VersionHistory from '../../../../utils/VersionHistory';
import SelectSearch from '../../../../Core/Fields/Floating/SelectSearch';

function Tab1({ fulldata, order_id, setorder_id, salesData,activityboll,picklist_id }) {
    console.log(salesData.sales_orders, "salesData.sales_lists");

    const [showActivity, setShowActivity] = useState(true);

    return (
        <div
            className="row sidebarbox m-0"
            style={{ padding: "8px", borderRadius: "5px", height: '70vh', overflowY: 'scroll', fontSize: '12px' }}
        >
            {/* Top Section */}
            <div style={{ height: '28vh' }}>
                <div className="d-flex gap-2" style={{ marginBottom: '12px' }}>

                    <div className="col-md-6 " style={{ flex: '1' }}>
                        <div className="mb-1" style={{height: '35px' }}>
                            <SelectSearch
                                list={salesData.sales_orders || []}
                                label="Sales Order"
                                getOptionLabel={(item) => item.name}
                                getOptionValue={(item) => item.name}
                                value={order_id}
                                onChange={(value) => setorder_id(value)}
                                placeholder=""
                            />
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className="mb-1">
                            <div className="custom-date-wrapper">
                                <label className="custom-date-label active-tab" htmlFor="orderdatepo">Order Date</label>
                                <input
                                    type="date"
                                    id="orderdatepo"
                                    className="form-control custom-date-input"
                                    style={{ fontSize: '0.8rem', padding: '0.375rem 11px', height: '35px' }}
                                    value="2025-05-20"
                                    readOnly
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-12" style={{ marginBottom: '12px' }}>
                    <div className="position-relative floating-select-wrapper">
                        <div
                            className="form-control custom-date-input floating-select-input"
                            style={{ fontSize: '0.8rem', padding: '0.375rem 11px', height: '35px' }}
                        >
                            {fulldata?.message.purpose}
                        </div>
                        <label className="custom-date-label active-tab">Purpose</label>
                    </div>
                </div>

                <div className="col-12" style={{ marginBottom: '12px' }}>
                    <div className="position-relative floating-select-wrapper">
                        <div
                            className="form-control custom-date-input floating-select-input"
                            style={{ fontSize: '0.8rem', padding: '0.375rem 11px', height: '35px' }}
                        >
                            WO-000456
                        </div>
                        <label className="custom-date-label active-tab">Work Order</label>
                    </div>
                </div>

                <div className="col-12" style={{ marginBottom: '12px' }}>
                    <div className="mb-3 position-relative floating-date-wrapper">
                        <input
                            type="date"
                            id="deliveryDate"
                            className="form-control custom-date-input floating-date-input"
                            style={{ fontSize: '0.8rem', padding: '0.375rem 11px', height: '35px' }}
                            value="2025-05-22"
                            readOnly
                        />
                        <label htmlFor="deliveryDate" className="custom-date-label active-tab">Delivery Date</label>
                    </div>
                </div>
            </div>

            {/* Middle Section */}
            <div style={{ marginTop: '2px', height: '28vh' }}>
                <div>
                    <div className='d-flex pb-2'>
                        <input checked type="checkbox" style={{ width: '15px', height: '15px', marginRight: '5px' }} />
                        <label style={{ color: '#00000099', fontSize: '13px', marginTop: '-5px' }}>Consider Rejected Warehouses</label>
                    </div>
                    <p style={{ fontSize: '9px', color: '#00000099', marginTop: '-5px', marginLeft: '25px' }}>
                        Items under this warehouse will be suggested
                    </p>
                </div>

                <div className='' style={{ marginTop: '-10px', marginBottom: '11px' }}>
                    <input
                        type="text"
                        id="numberInput"
                        className="form-control"
                        placeholder="Remarks"
                        style={{ borderRadius: '6px', fontSize: '11px', height: '38px' }}
                        defaultValue="Some remarks here"
                    />
                </div>

                <div>
                    <div className='d-flex pb-2'>
                        <input checked type="checkbox" style={{ width: '15px', height: '15px', marginRight: '5px' }} />
                        <label style={{ color: '#00000099', fontSize: '13px', marginTop: '-5px' }}>Pick Manually</label>
                    </div>
                    <p style={{ fontSize: '9px', color: '#00000099', marginTop: '-5px', marginLeft: '25px' }}>
                        If enabled then system won't override the picked qty / batches / serial numbers.
                    </p>
                </div>

                <div>
                    <div className='d-flex pb-2' style={{ marginTop: '-11px' }}>
                        <input checked type="checkbox" style={{ width: '15px', height: '15px', marginRight: '5px' }} />
                        <label style={{ color: '#00000099', fontSize: '14px', marginTop: '-5px' }}>Ignore Pricing Rule</label>
                    </div>
                    <p style={{ fontSize: '9px', color: '#00000099', marginTop: '-4px', marginLeft: '25px' }}>
                        If enabled then system won't apply the pricing rule on the delivery note which will be created from the pick list
                    </p>
                </div>
            </div>

            {/* Activity Section */}
            <div style={{ height: '14vh' }}>
                <div className="col-12">
                    <div className="py-2 d-flex justify-content-between align-items-center" onClick={() => setShowActivity(!showActivity)}>
                        <p className="firstcolor m-0" style={{ fontWeight: 500, fontSize: '18px' }}>Activity</p>
                        <GetIcon iconName={showActivity ? "MdKeyboardArrowUp" : "MdKeyboardArrowDown"} size={22} />
                    </div>

                    {showActivity && (
                        <VersionHistory
                            doctype="Pick List"
                           docname={picklist_id}
                            activityboll={activityboll}
                        />
                    )}
                </div>
            </div>
        </div>
    );
}

export default Tab1;
